import UserCreationPage from '@/pages/admin/UserCreationPage/UserCreationPage.vue'

export default UserCreationPage
